import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseActivityLogService from "../services/case-activity-log-service";

export const caseActivityLogSearchQuery = z.object({
	search: z.string().optional(),
	status: z.string(),
	case_record_id: z.string(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const caseActivityLogsQueryOptions = (search?: z.infer<typeof caseActivityLogSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case-activity-log", search],
		queryFn: () => caseActivityLogService.list(transformSearch(search, ["search", "status"])),
		...options,
	});
};
